@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/global.variables' as globalVariables;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/spacing.variables' as spacing;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/colours.variables' as colours;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/breakpoints.variables' as breakpoints;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/fonts.variables' as fonts;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/2-tools/functions/global.functions' as globalFunctions;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/font-sizes.variables' as fontSizes;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/2-tools/placeholder/focus.placeholders' as
	focusPlaceholders;

$ontario-icon-margin-top: 0.125rem;

// Colour variables
$ontario-colour-back-to-top-background: #e6e6e6;
$ontario-colour-back-to-top--active-background: #b2b2b2;

.ontario-back-to-top,
// Fractal component style coverage ↓
.ontario-back-to-top--default {
	position: fixed;
	bottom: 5%;
	right: 2%;
	visibility: hidden;
	opacity: 0;
	transition: 0.1s ease-in-out;
	display: flex;
	justify-content: center;
	align-items: center;
	height: globalFunctions.px-to-rem(48);
	padding: spacing.$spacing-2 spacing.$spacing-4 spacing.$spacing-2 spacing.$spacing-3;
	background: $ontario-colour-back-to-top-background;
	border: globalFunctions.px-to-rem(2) solid colours.$ontario-colour-white;
	border-radius: globalVariables.$global-radius;
	box-shadow: 0 globalFunctions.px-to-rem(2) globalFunctions.px-to-rem(4) rgba(colours.$ontario-colour-black, 0.6);
	box-sizing: border-box;
	color: colours.$ontario-colour-black;
	line-height: globalFunctions.px-to-rem(20);
	font-size: fontSizes.$ontario-font-size-standard-body-text;
	font-family: fonts.$ontario-font-open-sans;
	font-weight: fontWeights.$ontario-font-weights-semi-bold;
	z-index: 10000;
	cursor: pointer;

	.ontario-icon {
		margin: $ontario-icon-margin-top spacing.$spacing-2 spacing.$spacing-0 spacing.$spacing-0;
		width: globalFunctions.px-to-rem(32);
		height: globalFunctions.px-to-rem(32);
	}

	&:hover {
		background-color: colours.$ontario-greyscale-20;
	}

	&:focus {
		background-color: $ontario-colour-back-to-top-background;
		box-shadow:
			0 0 0 globalFunctions.px-to-rem(4) colours.$ontario-colour-focus,
			0 globalFunctions.px-to-rem(3) globalFunctions.px-to-rem(5) globalFunctions.px-to-rem(3) rgba(0, 0, 0, 0.6);
		outline: globalFunctions.px-to-rem(4) solid transparent;
		transition: 0.1s ease-in-out;
	}

	&:active {
		background-color: $ontario-colour-back-to-top--active-background;
		box-shadow:
			0 0 0 globalFunctions.px-to-rem(4) colours.$ontario-colour-focus,
			0 globalFunctions.px-to-rem(5) globalFunctions.px-to-rem(7) globalFunctions.px-to-rem(3) rgba(0, 0, 0, 0.6);
		outline: globalFunctions.px-to-rem(4) solid transparent;
		transition:
			background-color 0s,
			focusPlaceholders.$ontario-focus-transition;
	}

	@media screen and (max-width: breakpoints.$medium-breakpoint) {
		flex-direction: column;
		height: globalFunctions.px-to-rem(76);
		padding: globalFunctions.px-to-rem(6) spacing.$spacing-3 globalFunctions.px-to-rem(9) spacing.$spacing-3;

		.ontario-icon {
			margin: globalFunctions.px-to-rem(1) spacing.$spacing-0 spacing.$spacing-1 spacing.$spacing-0;
			width: globalFunctions.px-to-rem(32);
			height: globalFunctions.px-to-rem(32);
		}
	}

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		display: block;
		padding: spacing.$spacing-1;
		font-size: 0;
		width: globalFunctions.px-to-rem(48);
		height: globalFunctions.px-to-rem(48);

		.ontario-icon {
			margin: spacing.$spacing-2 spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-0;

			@-moz-document url-prefix() {
				margin-top: $ontario-icon-margin-top;
			}
		}
	}

	&.active {
		visibility: visible;
		opacity: 1;
	}
}
